import api from './api';

export const reportService = {
    getFilters: async () => {
        const res = await api.get('/reports/filters');
        return res.data;
    },

    getReport: async (type: string, params?: any) => {
        const res = await api.get(`/reports/${type}`, { params });
        return res.data;
    },

    exportReport: async (type: string, format: 'pdf' | 'excel' | 'csv', params?: any) => {
        try {
            const res = await api.get(`/reports/${type}/export`, {
                params: { ...params, format },
                responseType: 'arraybuffer',
            });
            
            // ✅ Check if response is JSON (usually means an error message)
            const contentType = res.headers['content-type'] || '';
            if (contentType.includes('application/json')) {
                const decoder = new TextDecoder('utf-8');
                const jsonText = decoder.decode(res.data);
                const errorData = JSON.parse(jsonText);
                throw new Error(errorData.message || 'Gagal mengekspor laporan.');
            }
            
            return res.data;
        } catch (error: any) {
            // ✅ Handle if axios already threw (e.g. 4xx/5xx naturally)
            if (error.response?.data instanceof ArrayBuffer) {
                const contentType = error.response.headers?.['content-type'] || '';
                if (contentType.includes('application/json')) {
                    const decoder = new TextDecoder('utf-8');
                    const jsonText = decoder.decode(error.response.data);
                    try {
                        const errorData = JSON.parse(jsonText);
                        error.message = errorData.message || error.message;
                    } catch (e) {
                        // ignore parse error, use original
                    }
                }
            }
            throw error;
        }
    },
};
